<template>
  <div>
    <a-button type="primary" icon="plus-circle" @click="openModel(0)" style="margin-bottom:15px"> 新增电子期刊 </a-button>
    <div class="publish-table">
      <a-table size="middle" :columns="columns" :loading="loading" :rowKey="record=>record.id" :data-source="publishList" :pagination="false">
        <span slot="id" slot-scope="text"> {{ text }}</span>
        <img class="cover" slot="cover" slot-scope="text" :src="text" alt="">
        <img class="cover" slot="background_cover" slot-scope="text" :src="text" alt="">
        <span slot="issue_time" slot-scope="text">{{ text | time }}</span>
        <span slot="created_at" slot-scope="text">{{ text | time }}</span>
        <template slot="issue" slot-scope="text">
          <span v-if="text == 1">已发布</span>
          <span style="color:red;" v-else>未发布</span>
        </template>
        <div slot="operate" slot-scope="text, record">
          <a-button type="link" v-if="record.issue == 1" @click="check(record)">
            查看
          </a-button>
          <a-button type="link" @click="edit(record.id)">
            编辑
          </a-button>
          <!-- <a-button class="btn" type="primary" v-if="record.issue == 0">
            <router-link :to="`/electrinic-journals/edit?id=${record.id}`">期刊设置</router-link>
          </a-button> -->
          <a-button @click="remove('delete', record)" type="link" v-if="record.issue==0">
            删除
          </a-button>
        </div>
      </a-table>
    </div>
    <a-modal title="期刊设置" @ok="submitForm" @cancel="handleCancel" :visible="newJournalVisible" :confirm-loading="confirmLoading">
      <a-spin :spinning="pdfloading">
        <a-form-model ref="newJournalForm" :model="form" :rules="newPublishRules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="发布时间:" prop="issue_time">
            <a-date-picker v-model="form.issue_time" show-time placeholder="请选择发布时间" :disabledDate="disabledDate" />
          </a-form-model-item>
          <a-form-model-item label="期刊年份:" prop="year">
            <a-select v-model="form.year" allowClear show-search option-filter-prop="children" placeholder="请选择期刊年份">
              <a-select-option v-for="item in journalYear" :key="item.value" :value="item.value">
                <a-tooltip placement="topLeft" :title="item.label" arrow-point-at-center>
                  {{ item.label }}
                </a-tooltip>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="期刊封面:">
            <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload" list-type="picture-card" class="avatar-uploader" :show-upload-list="true" :action="`${baseURL}/public/upload-file-qi-niu`" @change="(data) => handleChange(data)" :file-list="fileList" @preview="preview">
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <span>支持jpg/png 不超过2M，<br>比例限制（123*168），适配尺寸</span>
          </a-form-model-item>
          <!-- <a-form-model-item label="期刊书背:">
            <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload" list-type="picture-card" class="avatar-uploader" :show-upload-list="true" :action="`${baseURL}/public/upload-file-qi-niu`" @change="(data) => handleChangeBackground(data)" :file-list="backgroundList" @preview="preview">
              <div v-if="backgroundList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <span>支持jpg/png 不超过2M，<br>比例限制（123*168），适配尺寸</span>
          </a-form-model-item> -->
          <a-form-model-item label="PDF上传:">
            <a-upload :file-list="filePdf" :remove="handleRemove" :customRequest="beforeUploadPdf" @preview="previewPdf">
              <div v-if="filePdf.length < 1">
                <a-button>
                  <a-icon type="upload" /> Upload
                </a-button>
              </div>
            </a-upload>
          </a-form-model-item>
          <a-form-model-item label="期刊标题:" prop="title">
            <a-input placeholder="请输入" v-model="form.title" allow-clear></a-input>
          </a-form-model-item>
          <a-form-model-item label="期刊描述:" prop="subtitle">
            <a-textarea type="textarea" placeholder="请输入期刊内容" allow-clear v-model="form.subtitle" />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>

    <a-modal :visible="previewVisible" width="720px" :footer="null" @cancel="preViewCancel">
      <div class="preViewImg">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
    <covers :newJournalForm="newJournalForm" :ischeck="ischeck" @changeVisible="(v) => {this.ischeck = v;}"></covers>
    <a-pagination style="text-align: right; margin-top: 20px" size="small" :total="pagination.total" :defaultPageSize="10" show-size-changer show-quick-jumper :current="pagination.page" @change="(page, size)=> pageChange(page, size)" @showSizeChange="(page, size)=> pageChange(page, size)" />
  </div>
</template>
<script>
import { publistColumns, newPublishRules, journalYear } from '../business/journalList'
import { createJournal, JournalDelete, JournalDetail, JournalEdit } from '@/api/journal/index'
import moment from 'moment'
import token from '@/composables/token'
import { OSSClient } from '../editJournal/oss'
import { strategyCommand } from '../business/tableList'
import api from '@/api'
import Covers from './cover.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    publishList: {
      type: Array,
      default() {
        return []
      }
    },
    activityTab: {
      type: Number,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapState({ labels: state => state.label.data })
  },
  components: {
    Covers
  },
  data() {
    return {
      journalYear,
      pdfloading: false, // 上传pdfloading
      // 新增表单
      form: {
        title: '',
        year: moment(new Date()).format('YYYY'),
        subtitle: '',
        cover: '',
        issue_time: null,
        pdf_url: '',
        pdf_title: ''
      },
      ischeck: false,
      newJournalForm: {
        cover: '',
        title: '',
        activity_start: '',
        activity_end: ''
      },
      fileList: [],
      // backgroundList: [],
      baseURL: process.env.VUE_APP_API_BASE_URL,
      ...token(),
      newPublishRules: newPublishRules,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      confirmLoading: false,
      newJournalVisible: false,
      columns: publistColumns,
      loading: false,
      journalList: [],
      modelType: 0, // 弹窗类型，0：新增，1：修改，默认为0
      journalId: '', // 存放期刊临时修改，用于编辑期刊
      previewVisible: false,
      previewImage: '',
      filePdf: []
    }
  },
  filters: {
    time(msg) {
      return (msg = moment(msg * 1000).format('YYYY-MM-DD HH:mm:ss'))
    }
  },
  methods: {
    moment,
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    pageChange(page, size) {
      this.pagination.page = page
      this.pagination.per_page = size
      this.$emit('updateList')
    },
    handleChange(data) {
      this.fileList = data.fileList
      this.form.cover = data.fileList[0]?.response
        ? this.labels.QI_NIU_DOMAINS + '/' + data.fileList[0].response.data.url
        : ''
    },
    // handleChangeBackground(data) {
    //   this.backgroundList = data.fileList
    //   this.form.background_cover = data.fileList[0]?.response
    //     ? this.labels.QI_NIU_DOMAINS + '/' + data.fileList[0].response.data.url
    //     : ''
    // },
    /**
     * 通过modelTyp来判断是新增还是编辑框，进行数据处理
     */
    submitForm() {
      this.$refs.newJournalForm.validate(valid => {
        if (valid) {
          const query = this.modelType === 0 ? createJournal : JournalEdit
          const param = JSON.parse(JSON.stringify(this.form))
          param.issue_time = moment(param.issue_time).format('YYYY-MM-DD HH:mm:ss')
          if (this.modelType !== 0) {
            param.id = this.journalId
          }
          query(param).then(res => {
            if (this.$validate(res)) {
              this.form = {
                issue_time: null
              }
              this.filePdf = []
              this.fileList = []
              this.backgroundList = []
              this.newJournalVisible = false
              this.$message.success(`${this.modelType === 0 ? '新增' : '修改'}成功~`)
              this.$emit('updateList')
            }
          })
        }
      })
    },
    /**
     * @param {type} 判断弹出窗类型 0:新增电子期刊，1:编辑电子期刊
     * @param {id} 判断弹出窗类型 0:新增电子期刊，1:编辑电子期刊
     */
    openModel(type) {
      this.newJournalVisible = true
      this.modelType = type
    },
    /**
     * {id} 电子期刊id
     */
    async edit(id) {
      this.journalId = id
      const detail = await JournalDetail(id)
      if (detail.code === '000000') {
        const params = {
          title: detail.data.periodical.title,
          year: detail.data.periodical.year,
          subtitle: detail.data.periodical.subtitle,
          cover: detail.data.periodical.cover,
          background_cover: detail.data.periodical.background_cover,
          pdf_url: detail.data.periodical.pdf_url,
          issue_time: moment(detail.data.periodical.issue_time * 1000).format('YYYY-MM-DD HH:mm:ss')
        }
        this.form = { ...this.form, ...params }
        // this.fileList.push({
        //   uid: '-1',
        //   name: '书背.png',
        //   status: 'done',
        //   url: detail.data.periodical.cover
        // })
        if (detail.data.periodical.pdf_url !== '') {
          this.filePdf.push({
            uid: +new Date(),
            name: detail.data.periodical.pdf_title,
            status: 'done',
            url: detail.data.periodical.pdf_url
          })
        }
        this.openModel(1)
      }
    },
    disabledDate(current) {
      // Can not select days before today and today
      return (
        current &&
        current <
          moment()
            .subtract(1, 'days')
            .endOf('day')
      )
    },
    // 删除
    remove(type, ...arg) {
      strategyCommand[type].call(this, ...arg)
    },
    check(record) {
      this.ischeck = true
      Object.assign(this.newJournalForm, record, {
        activity_start: record.created_at,
        activity_end: record.issue_time
      })
    },
    handleCancel() {
      this.$refs.newJournalForm.resetFields()
      this.ischeck = false
      this.newJournalVisible = false
      this.form = {
        year: moment(new Date()).format('YYYY'),
        issue_time: null,
        pdf_url: '',
        pdf_title: void 0
      }
      this.fileList = []
      this.backgroundList = []
      this.filePdf = []
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isJpgOrPng =
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/png' ||
          file.type === 'image/gif'
        if (!isJpgOrPng) {
          this.$message.error('请上传图片!')
          return reject(new Error(false))
        }
        const isLt2M = file.size / 1024 / 1024 <= 2
        if (!isLt2M) {
          this.$message.error('图片大小不超过 2MB!')
          return reject(new Error(false))
        }
        return resolve(true)
      })
    },
    async beforeUploadPdf(file) {
      const fileTypes = ['application/pdf']
      if (!fileTypes.includes(file.file.type)) {
        this.$message.error('请上传pdf！')
        return false
      }
      if (file.file.type === 'application/pdf') {
        this.pdfloading = true
        const client = await OSSClient()
        const uploadPath = `${client.options.dir}/${new Date().getTime()}_${file.file.name}`
        await this.handleUpload(file.file, uploadPath, client).then(res => {
          if (res) {
            file.file.url = res.url
            this.filePdf.push(file.file)
            this.form.pdf_url = res.url
            this.form.pdf_title = file.file.name
            this.pdfloading = false
          }
        })
      } else {
        this.pdfloading = false
        return false
      }
    },
    async handleUpload(file, fileName, client) {
      try {
        const _this = this
        // 分片上传
        const res = await client.multipartUpload(fileName, file, {
          progress: async function(p) {
            _this.videoUploadPercent = Number((p * 100).toFixed(0))
          }
        })
        const url = res.res.requestUrls[0].split('?')[0]
        return { url: url, name: fileName }
      } catch (err) {
        this.$message.error(`${fileName}上传失败`)
      }
    },
    handleRemove() {
      this.filePdf = []
    },
    preview(file) {
      this.previewImage = file.url || this.labels.QI_NIU_DOMAINS + '/' + file.response.data.url
      this.previewVisible = true
    },
    previewPdf(file) {
      window.open(file.url, '_blank')
    },
    preViewCancel() {
      this.previewVisible = false
    }
  },
  mounted() {
    this.$emit('updateList', this.pagination)
  }
}
</script>

<style scoped lang="less">
.cover {
  width: 100px;
  height: 60px;
}
.btn {
  margin-right: 20px;
}
.preViewImg {
  padding: 10px 20px;
}
</style>
